/* eslint-disable @typescript-eslint/no-require-imports */
import { elapsed } from 'server/utils/elapsed';

const stats = () => {
  if (__SERVER__) {
    // this has to be imported synchronously, hot-shots depends on a module and is therefore incompatible client side
    const {
      restEntryMessage,
      restExitErrorMessage,
      restExitSuccessMessage,
    } = require('utils/logging');

    const { api, increaseRequestCounter, decreaseRequestCounter } = require('server/utils/stats');

    return {
      restTime: () => {
        const start = process.hrtime();
        return (url, status) => api({ url, status, ms: elapsed(start) });
      },
      restEntryMessage,
      restExitErrorMessage,
      restExitSuccessMessage,
      increaseRequestCounter,
      decreaseRequestCounter,
    };
  }

  return {
    restTime: () => () => {},
    restEntryMessage: () => {},
    restExitErrorMessage: () => {},
    restExitSuccessMessage: () => {},
    increaseRequestCounter: () => {},
    decreaseRequestCounter: () => {},
  };
};

export default stats();
